<template>
  <div class="company-sankey contrast">
    <div class="contrast-title" v-if="cItem.hide_title == 0">
      <img :src="$store.state.static_img_url + 'pic/module_tct_icon.png'" />{{cItem.title}}
    </div>
    <div class="contrast-summary" v-html="cItem.summary"></div>
    <div class="chart" :id="'sabkey' + cItem.id"></div>
    <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
    <div class="spa">
      <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
        <i class="iconfont">&#xe641;</i>
        <div slot="content" class="share_cnt clear">
          <div class="share_img"></div>
          <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
        </div>
      </Poptip>
    </div>
    <Modal
      v-model="detail_modal"
      class="detail-modal"
      width="500"
      @on-visible-change=""
      >
      <div slot="header">{{active_name}}(共{{show_list.length}}起)</div>
      <div class="list">
        <div v-for="item,index in show_list" :key="index">
          <i class="iconfont">&#xe645;</i>
          <div class="li-top">
            <span @click="goTopicDetail(item.news_topic_uid)">{{item.news_topic_title}}</span>
          </div>
          <div class="li-bto">
            <span>{{item.oldest_news_publish_time | time_moment}}</span>
            <span>性质：{{item.business_nature | dealName(meta.tct_business_nature)}}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="detail_modal = !detail_modal">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { option } from "js/chart_sabkey";
import echarts from "echarts";
import filter from "js/filter";
export default {
  props: ["cItem", "paramsUid", "meta"],
  data() {
    return {
      option: option,
      filter: filter,
      my_chart: "",
      show_list: [],
      active_name: [],
      detail_modal: false,
      nodes: [],
      links: [],
      autoHeight: 0
    };
  },
  methods: {
    goTopicDetail(uid) {
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, '_blank')
    },
    greatChart() {
      let chart = echarts.init(document.getElementById("sabkey" + this.cItem.id));
      this.option.series[0].links = this.links;
      this.option.series[0].data = this.nodes;
      let type2 = this.nodes.filter(item => item.type == 2)
      let type4 = this.nodes.filter(item => item.type == 4)
      let len2 = this.links.filter(item => {
        let i = type2.findIndex(a => a.name == item.source)
        return i > -1
      }).length
      let len4 = this.links.filter(item => {
        let i = type4.findIndex(a => a.name == item.target)
        return i > -1
      }).length
      let hgt = Math.max(len2, len4) * 38
      chart.resize({height: hgt})
      let arr = [];
      chart.setOption(this.option);
      chart.off("click");
      chart.on("click", params => {
        if(params.data.type == 3) {
          this.active_name = params.data.name
          this.show_list = this.cItem.content.res.filter(a => a.business_desc == params.data.name)
          this.detail_modal = true
        }
      });
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareScatter?tct_id='+this.cItem.id+'&theme_uid=' + theme_uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    let allowing = []
    this.cItem.content.res.map(a => {
      if (a.business_desc != null && a.business_nature != null && a.entity_ntag_id) {

        let ptag_name = this.filter.getPgidName(a.entity_ntag_id, this.meta.entity_ntag),
          tag_name = this.filter.getPidName(a.entity_ntag_id, this.meta.entity_ntag),
          business_desc = a.business_desc,
          business_name = this.filter.dealName(a.business_nature, this.meta.tct_business_nature)

        allowing.push(
          {source: ptag_name, target: tag_name, value: 1},
          {source: tag_name, target: business_desc, value: 1},
          {source: business_desc, target: business_name, value: 1}
        )

        // 一级
        let index1 = this.nodes.findIndex(b => b.name == ptag_name)
        if (index1 == -1) {
          this.nodes.push({ name: ptag_name , type: 1, value: 1, value1: 1});
        } else {
          this.nodes[index1].value1++
        }
        // 二级
        let index2 = this.nodes.findIndex(b => b.name == tag_name)
        if (index2 == -1) {
          this.nodes.push({ name: tag_name , type: 2, value: 1, value1: 1});
        } else {
          this.nodes[index2].value1++
        }
        // 三级
        let index3 = this.nodes.findIndex(b => b.name == business_desc);
        if (index3 == -1) {
          this.nodes.push({ name: business_desc , type: 3, value: 1, value1: 1});
        } else {
          this.nodes[index3].value1++
        }
        // 四级
        let index4 = this.nodes.findIndex(b => b.name == business_name)
        if (index4 == -1) {
          this.nodes.push({ name: business_name , type: 4, value: 1, value1: 1});
        } else {
          this.nodes[index4].value1++
        }

      }
    });
    allowing.map(a => {
      let index = this.links.findIndex(b => b.source == a.source && b.target == a.target)
      if (index == -1) {
        this.links.push(a)
      } else {
        // this.links[index].value++
      }
    })
    // if(this.cItem.id == 94) {
    //   console.log('nodes', this.nodes)
    //   console.log('links', this.links)
    // }
  },
  mounted() {
    this.greatChart();
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/constrast.stylus'
.chart
  width 700px
  commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
.detail-modal
  >>> .ivu-modal-wrap .ivu-modal .ivu-modal-content .ivu-modal-body .list
    max-height: 343px
    > div
      .li-bto span
        color: #999
</style>
